module.exports = __webpack_public_path__ + "img/personality.82728dcf.jpg";